import React, { Component } from 'react';

import ReportsListDisplay from 'components/reports/ReportsListDisplay';

class CustomSurveyReport extends Component {
  constructor() {
    super();
    this.state = {
      report: [],
    };
  }

  componentWillMount() {
    this.props.fetchReport();
  }

  render() {
    const {
      collapseReport,
      match,
      fetchReport,
      report,
      changeReportRange,
      startDate,
      endDate,
      isPublic,
    } = this.props;
    return (
      <ReportsListDisplay
        collapseReport={collapseReport}
        match={match}
        showDateFilter={true}
        fetchReport={fetchReport}
        report={report}
        changeReportRange={changeReportRange}
        startDate={startDate}
        endDate={endDate}
        isPublic={isPublic}
      />
    );
  }
}

export default CustomSurveyReport;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/reports/CustomSurveyReport.js